import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import ChecklistEditor from '../components/ChecklistEditor';

const AdminPage = () => {
  const [password, setPassword] = useState('');
  const [authenticated, setAuthenticated] = useState(false);

  const handleLogin = () => {
    if (password === 'admin123') {
      setAuthenticated(true);
    } else {
      alert('Invalid password.');
    }
  };

  if (!authenticated) {
    return (
      <Container className="container">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <Card className="card" sx={{ maxWidth: 400, mx: 'auto' }}>
            <CardContent>
              <Typography variant="h6" color="primary" mb={2}>
                Admin Login
              </Typography>
              <TextField
                fullWidth
                label="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                sx={{ mb: 2 }}
                margin="normal"
              />
              <Button
                variant="contained"
                fullWidth
                onClick={handleLogin}
                sx={{
                  background: 'linear-gradient(45deg, #1976d2, #7b1fa2)',
                  '&:hover': { background: 'linear-gradient(45deg, #1565c0, #6a1b9a)' },
                }}
              >
                Login
              </Button>
            </CardContent>
          </Card>
        </motion.div>
      </Container>
    );
  }

  return (
    <Container className="container">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Card className="card">
          <CardContent>
            <ChecklistEditor />
          </CardContent>
        </Card>
      </motion.div>
    </Container>
  );
};

export default AdminPage;